export default {
	section_banner: {
		title: {
			one: 'の使用',
		},
		main_title: {
			one: '国際的',
		},
		sub_title: {
			one: '標準ウォレット',
		},
		paragraph: {
			one: 'セキュリティで保護された自社ウォレット 外部ウォレット会社ではなく、自社の技術で開発されたウォレットを使用しています。',
		},
		cta_buttons: {
			one: 'アセットの送信',
			two: 'アプリをダウンロード',
		},
	},

	wallet_sec_rt: {
		label: 'セキュリティレベル2',
		title: {
			one: 'より高度なコンプライアンス',
			two: 'と',
			three: '国際的',
			four: '規格',
		},
		paragraph:
			'セキュリティに関しては細心の注意を払い、システムのあらゆるレイヤーが脅威から保護されるよう万全を期しています。JPWorldPayは、ハッキングを完全にブロックするために、高度な暗号化、分散ストレージ、継続的な監視を採用しています。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	wallet_sec_lt: {
		label: '最速の支払いシステム',
		title: {
			one: 'ハッキング',
			two: '非常に',
			three: '難しい',
		},
		paragraph:
			'さらに、JPWorldPayは分散型ストレージの原則を採用し、中央障害点を最小限に抑えています。当社の暗号化プロトコルは、業界をリードする標準に基づいてすべてのトランザクションを保護します。プロアクティブなセキュリティ戦略を導入することで、お客様のデジタル資産は常に新たな脅威から保護されます。また、サイバーセキュリティの専門家と提携し、定期的な監査を実施し、インフラストラクチャを強化しています。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	received_request_sec: {
		label: '3ステップ決済',
		title: {
			one: 'あ',
			two: '財布',
			three: 'あなたのようなもの',
			four: '安全',
		},
		paragraph: {
			one: 'JPWorldPayでは独自のウォレットを開発し、ハッキング対策を最適化したセキュリティ対策を講じています。そのセキュリティには自信を持っています。システムは定期的にテストを行い、潜在的な脆弱性を特定・修正しています。お客様の資産は、高度な暗号化と多層防御によって保護されています。',
			two: 'さらに、不審なアクティビティを継続的に監視し、リアルタイムアラートを実装することで、脅威がお客様のアカウントに影響を与える前に検知・防止します。JPWorldPayでは、お客様のセキュリティを常に最優先に考えておりますので、安心してデジタル資産を管理していただけます。また、すべてのデータはアクセス制御された安全な環境に保管されます。開発チームは、サイバーセキュリティとコンプライアンスに関するベストプラクティスを遵守しています。あらゆる取引において、お客様のプライバシーと保護は当社のプラットフォームの中核を成しています。',
		},

		cta_buttons: {
			one: '今すぐ受け取る',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
